/** @jsxImportSource @emotion/react */
import React, { memo, useContext } from 'react'
import {
  LicenseInformationDataContext,
  LicenseInformationRecordType
} from '@signal/core/licenseInformation'
import Typography from '@signal/components/Typography'
import renderIf from '@signal/utils/renderIf'
import {
  InstructionTypography,
  LicenseTypography,
  LicenseWrapper,
  PackageTypography,
  RecordEntry,
  RecordWrapper,
  Wrapper
} from './styles'
import { LicenseInformationPropsType } from './types'

export const LicenseInformationComponent: React.FC<LicenseInformationPropsType> = () => {
  const licenseInformationData = useContext(LicenseInformationDataContext)
    .response as Array<LicenseInformationRecordType> | undefined
  const licensesToDisplay = licenseInformationData?.filter(
    licenseRecord => !licenseRecord.isBackendProject
  )
  return (
    <Wrapper>
      <Typography variant="body1">
        License information for third party software
      </Typography>
      <Typography variant="body1">
        used by the PureCars Application Portal
      </Typography>
      <InstructionTypography>
        Click on any package or license type for more details.
      </InstructionTypography>
      <LicenseWrapper>
        {renderIf(
          Boolean(licenseInformationData),
          () =>
            licensesToDisplay!.map(licenseRecord => (
              <RecordWrapper key={licenseRecord.packageName}>
                <RecordEntry>
                  <PackageTypography href={licenseRecord.projectLink}>
                    {licenseRecord.packageName}
                  </PackageTypography>
                  &nbsp;(
                  <LicenseTypography href={licenseRecord.licenseLink}>
                    {licenseRecord.licenseName}
                  </LicenseTypography>
                  )
                </RecordEntry>
              </RecordWrapper>
            )),
          () => (
            <>
              <Typography variant="body1" color="error">
                There was an error fetching the license data.
              </Typography>
              <Typography variant="body1" color="error">
                Please try again later.
              </Typography>
            </>
          )
        )}
      </LicenseWrapper>
    </Wrapper>
  )
}

export default memo(LicenseInformationComponent)
